/**
 *  [2022] Zettant Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Zettant Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Zettant Incorporated and its
 * suppliers and may be covered by Japan. and Foreign Patents,
 * patents in process, and are protected by trade secret or
 * copyright law. Dissemination of this information or
 * reproduction of this material is strictly forbidden unless
 * prior written permission is obtained from Zettant Incorporated.
 */

/**
 * :ZNOTE:
 * tag: node,browser,fetch
 * note:
 *  - nodeおよびブラウザの環境に依存せずfetch()を使える様にする
 * sample:
 *  -
 * :ZNOTE:
 */

/**
 * Get fetch
 */
export const getFetch = (): any => {
  let fetchX;
  // @typescript-eslint/no-implied-eval
  // eslint-disable-next-line @typescript-eslint/no-implied-eval,no-new-func
  const global = Function('return this;')();
  if (typeof window !== 'undefined') {
    fetchX = (window as any).fetch;
    if (typeof fetchX === 'undefined') { // for jest
      fetchX = require('node-fetch');
      global.fetch = fetchX;
    }
  } else {
    return fetch;  // testコードの先頭で jest.mock('node-fetch', () => require('node-fetch')); されていることが前提
  }
  return fetchX;
};
